import restApi from "./request";

export default restApi;